export const formatPhoneNumberInput = (value = '') => {
  const cleaned = String(value).replace(/\D/g, '').slice(0, 10);

  if (!cleaned) return '';
  if (cleaned.length <= 3) return cleaned;
  if (cleaned.length <= 6) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
  }
  return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
};

export const isCompletePhoneNumber = (value = '') => {
  return String(value).replace(/\D/g, '').length === 10;
};
